import { PROVIDER_TYPE } from 'straightline-utils/constants';
import { yup } from 'straightline-utils/validation';

export default (app) => {
  return yup.object({
    shipment_id: yup.string().id().label('Shipment ID').required(),
    carrier_rate_type: yup
      .string()
      .trim()
      .required()
      .oneOf([PROVIDER_TYPE.STRAIGHTLINE, PROVIDER_TYPE.FREIGHTWAVES])
      .label('Carrier Rate Type'),
    carrier_service_level: yup
      .string()
      .trim()
      .label('Service Level')
      .nullable(),
    carrier_phone: yup.string().trim().phone().label('Driver Phone').required(),
    carrier_driver: yup.string().trim().label('Driver Name').required(),
    carrier_tracking_url: yup.string().trim().label('Tracking URL').nullable(),
    carrier_truck_number: yup.string().trim().label('Truck Number').required(),
    carrier_trailer_number: yup
      .string()
      .trim()
      .label('Trailer Number')
      .required()
  });
};
